import { AccAppHeader } from 'accelerator-app-header';
import { HybridspaceDiagnostics } from 'hybridspace-diagnostics';
import { usePlacesDashboardLoadE2ECheckpoint } from 'hybridspace-performance-datapoints';
import microsoftPlacesLogo from 'owa-appbar-icons/lib/microsoftPlaces.svg';
import { getApplicationSettings } from 'owa-application-settings';
import { getLogicalRing } from 'owa-config';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import {
    appMicrosoftPlaces as strings_appMicrosoftPlaces,
    hybridspacePlacesTitle as strings_hybridspacePlacesTitle,
} from 'owa-locstrings/lib/strings/appMicrosoftPlaces.locstring.json';
import { observer } from 'owa-mobx-react';
import { PLACES_APP_NAME, PLACES_BRANDING_NAME } from 'places-common-strings';
import { type FunctionComponent, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { onSignoutClick } from 'places-signout';

export interface HybridspaceSuiteHeaderProps {
    compact: boolean;
}
const defaultExport: FunctionComponent<HybridspaceSuiteHeaderProps> = observer(
    function HybridspaceSuiteHeader({ compact }: HybridspaceSuiteHeaderProps) {
        const navigate = useNavigate();
        const navigateHome = useCallback(() => navigate('/'), [navigate]);
        // Enable smiley feedback for SDF users and OCV feedback for non-SDF users
        const isSdfUser = getLogicalRing() === 'Dogfood';
        const isSmileyFeedbackEnabled =
            isSdfUser || isGlobalFeatureEnabled('msplaces-dev-smileyFeedback');
        const isOCVEnabled = !isSdfUser || isGlobalFeatureEnabled('msplaces-dev-OCVFeedback');
        usePlacesDashboardLoadE2ECheckpoint(true /** successCondition */, 'nhm');

        const isDiagnosticsEnabled = getApplicationSettings('Diagnostics').panel;

        return (
            <AccAppHeader
                appId="Hybridspace"
                appIconSvg={microsoftPlacesLogo}
                appLogoSvg={microsoftPlacesLogo}
                appNameResourceId={strings_appMicrosoftPlaces}
                appNameString={PLACES_APP_NAME}
                appShortNameResourceId={strings_hybridspacePlacesTitle}
                appShortNameString={PLACES_BRANDING_NAME}
                appStatus={compact ? undefined : 'preview'}
                onAppNameClick={navigateHome}
                DiagnosticPanel={isDiagnosticsEnabled ? HybridspaceDiagnostics : undefined}
                onSignOut={onSignoutClick}
                showOCV={isOCVEnabled}
                showFeedback={isSmileyFeedbackEnabled}
                theme={'lightNeutral'}
                layout={'persona'}
            />
        );
    },
    'HybridspaceSuiteHeader'
);
export default defaultExport;
